"use client";

import { useCallback, useState } from "react";
import { AlertContext } from "@/providers/context.provider";
import { AlertPopup } from "../components/common/alertPopup.common";
import type { ReactNode } from "react";
type Alert = {
  id: string;
  message: string;
  success: boolean;
};
export type TAlertContext = {
  alerts: Alert[];
  showAlert: (message: string, success: boolean) => void;
  hideAlert: (id: string) => void;
};
export const AlertProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [alerts, setAlerts] = useState<Alert[]>([]);
  const showAlert = useCallback((message: string, success: boolean) => {
    const id = Date.now().toString();
    setAlerts(prev => [...prev, {
      id,
      message,
      success
    }]);
    setTimeout(() => {
      hideAlert(id);
    }, 5000);
  }, []);
  const hideAlert = useCallback((id_0: string) => {
    setAlerts(prev_0 => prev_0.filter(alert => alert.id !== id_0));
  }, []);
  return <AlertContext.Provider value={{
    alerts,
    showAlert,
    hideAlert
  }}>
            {children}
            {alerts.map(alert_0 => <AlertPopup key={alert_0.id} success={alert_0.success} message={alert_0.message} onClose={() => hideAlert(alert_0.id)} />)}
        </AlertContext.Provider>;
};